import { Color, Hyperlink, HyperlinkProps } from 'zens-storybook'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { Company } from 'zens-store'

interface Props extends HyperlinkProps {
  company: Company
}
const CompanyPin = (props: Props) => {
  const { company, ...otherProps } = props
  return (
    <Hyperlink
      left="pin"
      onPress={() => company.togglePinned()}
      disabled={company.togglePinned.inProgress}
      textStyle={{ color: company.isPinned ? Color.greyBlue : Color.calmGrey }}
      {...otherProps}
    />
  )
}

export default observer(CompanyPin)
